import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});


export const Schema = Yup.object().shape({
  initialData: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required('Nome da unidade é obrigatório'),
      address: Yup.string().required('Endereço é obrigatório'),
      number: Yup.string().required('Número é obrigatório'),
      neighborhood: Yup.string().required('Bairro é obrigatório'),
      estado: Yup.string().required('Estado é obrigatório'),
      id_city: Yup.string().required('Cidade é obrigatória'),
      lat: Yup.string().required('Latitude é obrigatória'),  
      lng: Yup.string().required('Longitude é obrigatória') 
    })
  )
});
export default Schema;
